// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__hujVk","topBottomGutter":"Layout_topBottomGutter__163LO"};